import React from 'react';
import styled, { keyframes } from 'styled-components';

const trailSpin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const TrailElement = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
  z-index: 10;
  padding: ${({ $borderWidth }) => $borderWidth || '2px'};

  /* Mask: only the padding area (border strip) is visible */
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
      from 0deg,
      transparent 0%,
      transparent 55%,
      ${({ $c1 }) => $c1} 65%,
      ${({ $c2 }) => $c2} 80%,
      ${({ $c3 }) => $c3} 95%,
      transparent 100%
    );
    animation: ${trailSpin} ${({ $dur }) => $dur}s linear infinite;
  }
`;

/**
 * BorderTrail — drop inside any container with `position: relative`
 * to get an animated gradient trail around its border.
 *
 * Props:
 *   color       — primary trail colour (default: '#854CE6')
 *   duration    — full-rotation time in seconds (default: 4)
 *   borderWidth — trail thickness CSS value (default: '2px')
 */
const BorderTrail = ({
  color = '#854CE6',
  duration = 4,
  borderWidth = '2px',
  style,
  className,
}) => {
  return (
    <TrailElement
      $c1={`${color}30`}
      $c2={`${color}99`}
      $c3={color}
      $dur={duration}
      $borderWidth={borderWidth}
      className={className}
      style={style}
    />
  );
};

export default BorderTrail;
